import { localeOptions } from "@/components/_localized/localizationData";
import validator, { PhoneLocale } from "validator";

export const required =
  (subject: string, customMessage?: string) => (v: any) => {
    if (!!v) {
      return true;
    } else {
      return customMessage || `${subject} is required`;
    }
  };

export const isMobilePhone =
  (
    locale: PhoneLocale = "en-US",
    errorMessage: string = "Valid mobile phone number is required"
  ) =>
  (v: any) => {
    const countryCode = localeOptions[locale]?.countryCode.replace("+", "");
    const parsedValue =
      locale !== "en-US"
        ? countryCode + v.replaceAll(" ", "").replace(/^0+/, "")
        : v;

    return validator.isMobilePhone(parsedValue, locale) || errorMessage;
  };

export const isEmail = (errorMessage?: string) => (v: any) => {
  const trimmedEmail = v.trim();
  return (
    validator.isEmail(trimmedEmail) || errorMessage || "Valid email is required"
  );
};

export const minAmount = (min: number) => (v: any) => {
  const cleanedV = v.toString().match(/\d+/g)?.[0];
  if (parseInt(cleanedV) >= min) {
    return true;
  } else {
    return ``;
  }
};

export const maxAmount = (max: number) => (v: any) => {
  const cleanedV = v.toString().match(/\d+/g)?.[0];
  if (parseInt(cleanedV) <= max) {
    return true;
  } else {
    return ``;
  }
};
